export default __webpack_public_path__ + "static/media/coin_eggp_bg.e4e31a43.png";